// extracted by mini-css-extract-plugin
export default {"wrap":"CategoryTabs_wrap__aQKv-","tab":"CategoryTabs_tab__hbxHM","active":"CategoryTabs_active__8Zbvs"};